import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChange } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Institution } from "../../../../../models/institution";
import { InstitutionUnit } from "../../../../../models/Institution-unit";
import { Registration } from "../../../../../models/registration";
import { RegistrationUnit } from "../../../../../models/registration-unit";
import { InstitutionControllerService } from "../../../../../services/institution-controller/institution-controller.service";
import { RegistrationInstitutionControllerService } from "../../../../../services/institution-controller/institution-registration-controller.service";
import { RoleInstitutionControllerService } from "../../../../../services/role-controller/role-institution-controller.service";
import { RoleUnitControllerService } from "../../../../../services/role-controller/role-unit-controller.service";
import { Store } from "../../../../../services/store.service";
import { UnitControllerService } from "../../../../../services/unit-controller/unit-controller.service";
import { RegistrationUnitControllerService } from "../../../../../services/unit-controller/unit-registration-controller.service";
import { UnitService } from "../../../../../services/unit-controller/unit.service";
import { environment } from "../../../../../../environments/environment";
import { TranslatedBaseError } from "../../../TranslatedBaseError";
import { TranslateService } from "@ngx-translate/core";
import {RegistrationInstitution} from "../../../../../models/registration-institution";

@Component({
  selector: "institution-unit",
  templateUrl: "unit.component.html",
  providers: [UnitControllerService, RegistrationUnitControllerService, InstitutionControllerService,
    RegistrationInstitutionControllerService, RoleInstitutionControllerService, RoleUnitControllerService, ToastrService],
})
export class UnitComponent extends TranslatedBaseError implements OnChanges, OnDestroy {

  @Input() public registration: Registration;
  @Input() public serviceId: string;
  @Input() public disabled: boolean = false;
  @Input() public registrationInstitution: RegistrationInstitution;
  @Output() public modalClosedEvent = new EventEmitter();
  @Output() public registrationUnitsLength = new EventEmitter();
  public institutionList: any[] = [];
  public registrationInstitutions: any[] = [];
  public registrationUnits: RegistrationUnit[];
  public registrationUnitsListLength: number;
  public institutionUnit: InstitutionUnit;
  public institutionUnits: InstitutionUnit[] = [];

  public searchInstitutionUnitFilter: any;

  public activityCondition: any;
  public addNew: boolean = false;
  public showList: boolean = false;
  public showInstitutionUnit = {};

  public subscription: any;

  constructor(private registrationUnitControllerService: RegistrationUnitControllerService, private institutionControllerService: InstitutionControllerService, private unitService: UnitService, public toastr: ToastrService, public translateService: TranslateService, public store: Store, private registrationInstitutionControllerService: RegistrationInstitutionControllerService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.unitService.update.subscribe((data) => {
      if (data.update) {
        this.reloadUnitList();
      }
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.registration && changes.registration.currentValue) {
      this.registration = changes.registration.currentValue;
      this.reloadUnitList();
    }
  }

  public reloadUnitList() {
    if (this.registration && this.registration.id) {
      this.registrationUnitControllerService.getRegistrationUnits(this.registration.id).subscribe(
        (data) => this.updateData(data),
      );
    }
  }

  public updateData(data: any) {
    if (!this.disabled) {
      this.showList = false;
      this.institutionUnits = [];
      this.institutionList = [];
      if (!this.registrationUnits) {
        this.registrationUnits = data;
      } else {
        if (data.length > 0) {
          if (!this.registrationUnits) {
            this.registrationUnits = [];
          }
          this.registrationUnits[0] = new RegistrationUnit();
          this.registrationUnits[0].unitId = data[0].unitId;
          this.registrationUnits[0].institutionId = data[0].institutionId;
          this.registrationUnits[0].id = data[0].id;
        } else {
          this.registrationUnits = data;
        }
      }

      this.registrationUnitsListLength = data.length;
      this.registrationUnitsLength.emit({ registrationUnitsLength: data.length });
      this.loadUnits();
    }
  }

  public deleteRegistrationUnit(isConfirmed: boolean, regUnitId: string) {
    if (!this.disabled && isConfirmed) {
      this.registrationUnitControllerService.deleteRegistrationUnit(regUnitId).subscribe(
        () => this.reloadUnitList(),
      );
    }
  }

  public loadUnits() {
    this.registrationInstitutions.length = 0;
    this.institutionControllerService.getInstitutionChildren(this.registrationInstitution).subscribe(
      (inst) => {
        this.registrationInstitutions.push(inst);
        this.addUnits(inst);
    });
  }

  public addUnits(inst: Institution) {
    if (inst.units) {
      for (const unit of inst.units) {
        this.institutionUnits.push(unit);
      }
      this.institutionUnits.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
      });
      this.getName(inst.units);
    }
  }

  public getName(units) {
    this.showInstitutionUnit = {};
    if (units != null && this.registrationUnits != null) {
      for (const entry of units) {
        this.showInstitutionUnit[entry.id] = true;
        for (const registrUnit of this.registrationUnits) {
          if (registrUnit.unitId === String(entry.id)) {
            registrUnit.name = entry.name;
            this.showInstitutionUnit[entry.id] = false;
          }
        }
      }
    }
  }

  public fixVisualEffectOnUnitSelected(institutionUnit): void {
    this.showList = false;
    const newRegUnit: RegistrationUnit = new RegistrationUnit();
    newRegUnit.registrationId = this.registration.id;
    newRegUnit.institutionId = institutionUnit.institution_id;
    newRegUnit.unitId = institutionUnit.id;
    newRegUnit.name = institutionUnit.name;
    this.registrationUnits = [newRegUnit];
  }

  public addRegistrationUnit(institutionUnit) {
    const selectedInstitutionUnit = institutionUnit[0];
    if (!this.disabled && this.registration) {
      const newRegUnit: RegistrationUnit = new RegistrationUnit();
      newRegUnit.registrationId = this.registration.id;
      newRegUnit.institutionId = selectedInstitutionUnit.institution_id;
      newRegUnit.unitId = selectedInstitutionUnit.id;
      if (this.registrationUnits.length > 0) {
        const activeRegUnitId = this.registrationUnits[0].id;

        // for visual effect
        this.fixVisualEffectOnUnitSelected(selectedInstitutionUnit);

        this.registrationUnitControllerService.createRegistrationUnit(this.registration.id, newRegUnit).subscribe(
          () => {
            this.responseSuccessful("Unit added to Registration!");
            this.reloadUnitList();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
        );
      } else {

        // for visual effect
        this.fixVisualEffectOnUnitSelected(selectedInstitutionUnit);

        this.registrationUnitControllerService.createRegistrationUnit(this.registration.id, newRegUnit).subscribe(
          () => {
            this.responseSuccessful("Unit added to Registration!");
            this.reloadUnitList();
          },
          (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
        );
      }
    }
  }

  public openEdit(regInstitutionUnit: any, name?: string) {
    if (!this.disabled && regInstitutionUnit) {
      this.addNew = false;
      if (Boolean(environment.KEYCLOAK_ACTIVE)) {
        return this.institutionControllerService.getInstitution(regInstitutionUnit.unitId).subscribe(
          (inst) => {
            const unit = new InstitutionUnit();
            unit.institution_id = regInstitutionUnit.institutionId; // parentId
            unit.id = inst.id;
            unit.name = inst.name;
            unit.url = inst.url;
            this.institutionUnit = unit;
            this.updateEditData();
          });
      }
      for (const institutionUnit of this.institutionUnits) {
        if (String(institutionUnit.id) === regInstitutionUnit.unitId) {
          this.institutionUnit = institutionUnit;
        }
      }

    } else {
      this.institutionUnit = new InstitutionUnit();
      if (name) {
        this.institutionUnit.name = name;
      } else if (this.searchInstitutionUnitFilter !== undefined) {
        this.institutionUnit.name = this.searchInstitutionUnitFilter.name;
      }
      this.addNew = true;
    }
    this.updateEditData();
  }

  public showOrAdd() {
    if (!this.disabled) {
      if (this.institutionUnits.length > 0 && this.registrationUnitsListLength !== this.institutionUnits.length) {
        this.showList = !this.showList;
      } else {
        this.openEdit(false);
      }
    }
  }

  public updateEditData() {
    if (!this.disabled) {
      this.showList = false;
      this.store.state.common.sections.type = "unit";
      this.unitService.registration = this.registration;
      this.unitService.institutionUnit = JSON.parse(JSON.stringify(this.institutionUnit)); // mini-hack so the list doesn't update when working in edit layer
      this.unitService.registrationInstitutions = this.registrationInstitutions;
      this.unitService.registrationUnits = this.registrationUnits;
      this.unitService.addNew = this.addNew;
      this.unitService.context = "registration";
      this.unitService.initEdit();
    }
  }

  public searchInstitutionUnitChanged(value: any): void {
    this.searchInstitutionUnitFilter = { name: value };
  }

}
